import { FlexeApiResponse } from '../CommonInterfaces';
import { apiRequestJSON, crossOriginRequestJson } from '../lib/flexeApi';
import {
  BillingLeverDetails,
  FilterOption,
  FilterOptionsByLeverId,
  PricingCatalog,
  PricingCatalogByLeverId,
} from './data/PricingCatalogInterfaces';

export class PricingCatalogService {
  public async retrievePricingCatalog(): Promise<PricingCatalog> {
    const response: FlexeApiResponse = await apiRequestJSON('GET', '/api/pricing_catalog');

    const { data, statusCode, error } = response;

    if ((statusCode === 200 || statusCode === 201) && data) {
      return data;
    } else if (error && typeof error !== 'string') {
      throw new Error(error.msg);
    }
  }

  public async retrieveFilterCatalog(): Promise<FilterOption[]> {
    const filterOptionsResponse = await crossOriginRequestJson('GET', '/api/v2/admin/pricing-catalog/filter-options');

    if (filterOptionsResponse.status !== 200) {
      throw new Error(`Could not load filter options; request returned status ${filterOptionsResponse.status}`);
    }

    const parsedFilterOptionsResponse = await filterOptionsResponse.json();

    return parsedFilterOptionsResponse.data.filter_options as FilterOption[];
  }

  // If you try to make an equivalent for this but by filterID note that there are separate entries per lever so you may lose enum values
  static groupFiltersByLeverId(filters: FilterOption[]): FilterOptionsByLeverId {
    const result: { [filterId: number]: FilterOption[] } = {};
    filters.forEach((filter) => {
      if (!result[filter.pricing_lever_id]) {
        result[filter.pricing_lever_id] = [];
      }
      result[filter.pricing_lever_id].push(filter);
    });
    return result;
  }

  static groupCatalogByLeverId(pricingCatalog: PricingCatalog): PricingCatalogByLeverId {
    const result: { [leverId: number]: BillingLeverDetails } = {};
    Object.keys(pricingCatalog).forEach((leverKey) => {
      if (pricingCatalog.hasOwnProperty(leverKey)) {
        const details = pricingCatalog[leverKey];
        result[details.id] = details;
      }
    });
    return result;
  }
}
